import { ReactNode } from "react";

import CardCollapsible from "ds/components/Card/Collapsible";
import Counter from "ds/components/Counter";
import { useToggle } from "hooks/useToggle";

type ModuleVersionCollapsibleSectionProps = {
  title: string;
  count: number;
  children: ReactNode;
};

const ModuleVersionCollapsibleSection = ({
  title,
  count,
  children,
}: ModuleVersionCollapsibleSectionProps) => {
  const [isCollapsed, toggle] = useToggle(false);

  return (
    <CardCollapsible
      ariaLevel={4}
      ariaLabel={title}
      title={title}
      isCollapsed={isCollapsed}
      onToggle={toggle}
      titleSuffix={<Counter count={count} />}
      fullbleed
    >
      {children}
    </CardCollapsible>
  );
};

export default ModuleVersionCollapsibleSection;
